import { render } from "./PendingUsers.vue?vue&type=template&id=7af761d2&scoped=true"
import script from "./PendingUsers.vue?vue&type=script&lang=js"
export * from "./PendingUsers.vue?vue&type=script&lang=js"

import "./PendingUsers.vue?vue&type=style&index=0&id=7af761d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7af761d2"

export default script